import { render, staticRenderFns } from "./BlockIconPreview.vue?vue&type=template&id=2f5486d0"
import script from "./BlockIconPreview.vue?vue&type=script&lang=js"
export * from "./BlockIconPreview.vue?vue&type=script&lang=js"
import style0 from "./BlockIconPreview.vue?vue&type=style&index=0&id=2f5486d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports